import { render, staticRenderFns } from "./ProductsInStockTrackAndTrace.vue?vue&type=template&id=591577f1&scoped=true"
import script from "./ProductsInStockTrackAndTrace.vue?vue&type=script&lang=js"
export * from "./ProductsInStockTrackAndTrace.vue?vue&type=script&lang=js"
import style0 from "./ProductsInStockTrackAndTrace.vue?vue&type=style&index=0&id=591577f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591577f1",
  null
  
)

export default component.exports